import { Box, Fab } from '@mui/material';
import { Call } from '@mui/icons-material';

import { PhoneDialerInputs } from './PhoneDialerInputs';
import { NumericKeypad } from './NumericKeypad';

import { callButtonStyles, modalStyles } from './styles';
import { PhoneDialerProps } from './types';

export const PhoneDialer = ({
  selectedCountry,
  dialNumber,
  onCountryChange,
  onNumberChange,
  onClearNumber,
  onKeyPress,
  onCall,
}: PhoneDialerProps) => (
  <Box
    sx={{
      ...modalStyles.mainContainer,
      backgroundColor: (theme) => theme.palette.background.paper,
      color: (theme) => theme.palette.text.primary,
    }}
  >
    <>
      <PhoneDialerInputs
        selectedCountry={selectedCountry}
        dialNumber={dialNumber}
        onCountryChange={onCountryChange}
        onNumberChange={onNumberChange}
        onClearNumber={onClearNumber}
      />
      <NumericKeypad onKeyPress={onKeyPress} />
    </>
    <Box sx={callButtonStyles.container} mt={2}>
      <Fab onClick={onCall} color="success" aria-label="call" size="large" sx={callButtonStyles.fab}>
        <Call />
      </Fab>
    </Box>
  </Box>
);
